import { RatingStars } from './RatingStars'

export interface RatingSummaryData {
  total: number
  average: number
  breakdown: Record<string, number>
  completed_orders?: number
}

interface RatingSummaryProps {
  data: RatingSummaryData
  onFilterByRating?: (rating: number | null) => void
  activeFilter?: number | null
}

export function RatingSummary({ data, onFilterByRating, activeFilter }: RatingSummaryProps) {
  const { total, average, breakdown } = data

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-6 bg-white border border-gray-200 rounded-lg">
      <div className="flex flex-col items-center justify-center text-center border-r border-gray-100 md:pr-6">
        <div className="text-5xl font-bold text-gray-900">{average.toFixed(1)}</div>
        <RatingStars value={average} size={20} />
        <div className="mt-2 text-sm text-gray-500">
          {total} avaliaç{total === 1 ? 'ão' : 'ões'}
        </div>
      </div>
      <div className="md:col-span-2 space-y-2">
        {[5, 4, 3, 2, 1].map((star) => {
          const count = breakdown?.[star] || 0
          const pct = total > 0 ? (count / total) * 100 : 0
          const isActive = activeFilter === star
          return (
            <button
              key={star}
              type="button"
              onClick={() => onFilterByRating?.(isActive ? null : star)}
              disabled={!onFilterByRating || count === 0}
              className={`w-full flex items-center gap-3 px-2 py-1 rounded transition-colors ${
                isActive ? 'bg-amber-50' : 'hover:bg-gray-50'
              } ${count === 0 ? 'opacity-50 cursor-default' : 'cursor-pointer'}`}
            >
              <span className="text-sm w-3 text-right text-gray-600">{star}</span>
              <RatingStars value={1} size={12} className="opacity-70" />
              <div className="flex-1 h-2 bg-gray-100 rounded-full overflow-hidden">
                <div
                  className="h-full bg-amber-400 transition-all"
                  style={{ width: `${pct}%` }}
                />
              </div>
              <span className="text-sm w-10 text-right text-gray-500">{count}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
